import React from 'react'
import Link from 'gatsby-link'
import PageTransition from 'gatsby-plugin-page-transitions'
import Mosaic from '../components/mosaic'
import MosaicMobile from '../components/mosaic-mobile'
import styled from 'styled-components'

import Responsive from 'react-responsive'

const Mobile = props => <Responsive {...props} maxWidth={767} />
const Desktop = props => <Responsive {...props} minWidth={992} />

const NavigationDimmer = styled.div`
  position: fixed;
  z-index: 1;
  width: 100vw;
  height: 10vw;
  background-color: white;
`

const NavigationDimmerMobile = styled.div`
  position: fixed;
  z-index: 1;
  width: 100vw;
  height: 35vw;
  background: linear-gradient(
    rgba(0, 0, 0, 0.6),
    rgba(0, 0, 0, 0.3),
    rgba(0, 0, 0, 0)
  );
`

const Projetos = () => (
  <PageTransition>
    <Desktop>
      <NavigationDimmer />
      <Mosaic />
    </Desktop>
    <Mobile>
      {/* <NavigationDimmerMobile /> */}
      <MosaicMobile />
    </Mobile>
  </PageTransition>
)

export default Projetos

export const query = graphql`
  query PortfolioQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/projetos.js